export default __webpack_public_path__ + "static/media/linkedin-logo.e2e1ca7f.svg";